module.exports = __webpack_public_path__ + "static/media/exp_anchorage_3.f0c84d3c.svg";